<template>
  <div class="relative flex-center">
    <div class="relative line-clamp-1">
      <button @click="copyText" :class="buttonClass">
        <svg
          class="flex-shrink-0"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 9.675V12.825C12 15.45 10.95 16.5 8.325 16.5H5.175C2.55 16.5 1.5 15.45 1.5 12.825V9.675C1.5 7.05 2.55 6 5.175 6H8.325C10.95 6 12 7.05 12 9.675Z"
            fill="#16CC53"
          />
          <path
            d="M12.8253 1.5H9.67531C7.46288 1.5 6.37452 2.25121 6.08673 4.05369C5.99892 4.60363 6.4628 5.0625 7.01972 5.0625H8.32531C11.4753 5.0625 12.9378 6.525 12.9378 9.675V10.9806C12.9378 11.5375 13.3967 12.0014 13.9466 11.9136C15.7491 11.6258 16.5003 10.5374 16.5003 8.325V5.175C16.5003 2.55 15.4503 1.5 12.8253 1.5Z"
            fill="#16CC53"
          />
        </svg>
        <span class="text-white text-sm" :class="titleClass" v-if="title">{{
          title
        }}</span>
      </button>
    </div>
    <Transition name="fade">
      <div
        v-if="copied"
        class="absolute -top-7 p-1 rounded bg-dark-100 z-[1000000]"
        :class="tooltipClass"
      >
        <p class="text-white text-xs">{{ $t("copied") }}</p>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { TClassName } from "@/types/common";

interface Props {
  text: string;
  title?: string;
  buttonClass?: TClassName;
  tooltipClass?: TClassName;
  titleClass?: TClassName;
}

const props = defineProps<Props>();

const copied = ref(false);

function copyText() {
  try {
    navigator.clipboard.writeText(props.text);
    copied.value = true;
    setTimeout(() => {
      copied.value = false;
    }, 1000);
  } catch (err) {
    console.error(err);
  }
}
</script>
